{
  "moreActions": "Більше дій"
}
